import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useShowContext } from 'react-admin';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { Order } from 'types/embedded/order';

import { StyledTypography } from './OrdersShowCommonInfoMain.styled';

export const OrdersShowCommonInfoMainIdField = (): JSX.Element => {
  const translate = useTypedTranslate();

  const { record: order } = useShowContext<Order>();
  const isMerchantIdEnabled = order?.orderExtendedInfo?.merchant_id_enabled;

  return (
    <FunctionField
      render={() => {
        if (isMerchantIdEnabled) {
          return <Typography variant="body2">{order?.originId}</Typography>;
        }
        return (
          <Tooltip
            arrow
            title={
              <Typography sx={{ fontSize: '10px' }}>
                {translate('app.common.idTransferredToTheProviderSide')}
              </Typography>
            }
          >
            <StyledTypography variant="body2">{order?.originId}</StyledTypography>
          </Tooltip>
        );
      }}
      sortable={false}
    />
  );
};
